<div *ngIf="readOnly; else editMode">
  <label class="bold questionGroupLabel">Business Type</label>
  <br />
  <label class="questionGroupLabel">{{ businessType }}</label>
</div>
<ng-template #editMode>
  <div class="field" *ngIf="showBecaToggle" class="show-Beca">
    <mat-slide-toggle
      color="primary"
      class="mat-slide-toggle toggle-style mat-primary ng-star-inserted"
      [checked]="getChecked"
      id="mat-slide-toggle-3-input"
      (change)="showBecaToggleChange($event)"
    >
      <label class="mat-slide-toggle-label" for="mat-slide-toggle-3-input">
        <span class="mat-slide-toggle-content">
          <span style="display: none">&nbsp;</span>
          <p>Show Beca</p>
        </span>
      </label>
    </mat-slide-toggle>
  </div>
  <business-type-component
    [showPrimaryBusinessType$]="showPrimaryBusinessType$"
    [hostType]="'CLBECA'"
    [data]="data"
    (outputEvent)="outputEventChange($event)"
    class="watsonPos"
  >
  </business-type-component>
</ng-template>
<div class="{{ readOnly ? 'bottom-pad' : '' }}" id="test"></div>
